import { BaseRecord, useList } from '@pankod/refine-core'
import moment from 'moment'
import { useEffect, useState } from 'react'
import './DislikeListContent.scss'

interface ContentProps {
    cmtId: number
}
export const DislikeContent = ({ cmtId }: ContentProps) => {
    const [likedList, setLikedList] = useState<BaseRecord>([])

    const likedListRes = useList({
        resource: `resourcesdislikes`,
        config: {
            filters: [
                {
                    field: 'resourcesId',
                    operator: 'eq',
                    value: cmtId
                }
            ],
            pagination: { current: 1, pageSize: 3000 }
        },
        metaData: {
            config: {
                fields: ['name', 'createdAt'],
                joins: [{ field: 'user', select: ['name'] }]
            }
        }
    }).data

    useEffect(() => {
        likedListRes && setLikedList(likedListRes.data)
    }, [likedListRes, likedList])
    const sortData = likedList.sort((a:any,b:any) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
    return (
        <div className="like-list-wrapper">
            {sortData.map((item: any) => {
                const time = item?.createdAt ? moment.utc(item?.createdAt).local().startOf('seconds').fromNow() : '--'
                return (
                    <div className="list-container" key={item.id}>
                        <span className="name">{item?.user?.name || 'loading...'}</span>
                        <span>-</span>
                        <span className="time">{time || 'loading...'}</span>
                    </div>
                )
            })}
        </div>
    )
}
